import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AuthForm"] */ "/vercel/path0/src/components/auth/auth-form.tsx");
